module.exports = __webpack_public_path__ + "img/spotify.45f13131.svg";